// eslint-disable-next-line no-unused-vars
function maskCpf(providedValue) {
  const digits = providedValue.replace(/\D/g, '').slice(0, 11);
  let masked = '';
  for (let i = 0; i < digits.length; i += 1) {
    masked += digits[i];
    if (i === 2 && digits.length > 3) {
      masked += '.';
    } else if (i === 5 && digits.length > 6) {
      masked += '.';
    } else if (i === 8 && digits.length > 9) {
      masked += '-';
    }
  }
  return masked;
}
